import { NavMenu } from '@shopify/app-bridge-react'
import Link from '@Shared/components/Link'
import {
  ROUTE_HOME,
  ROUTE_MARKETS,
  ROUTE_ONBOARDING,
  ROUTE_PREFERENCES,
  ROUTE_SUBSCRIPTION,
} from '@Shared/constants/routes'
import { useTranslation } from 'react-i18next'
import {
  useOnboardingActions,
  useOnboardingState,
} from '@Store/slices/onboarding'
import { useCacheState } from '@Store/slices/cache'
import { isMarketsUnlocked as isMarketsUnlockedFor } from '@Shared/constants/markets'

function MainMenu(): JSX.Element {
  const { t: translate } = useTranslation()

  const { isCompleted, isOnboardingStarted, menuItemClicked } =
    useOnboardingState()

  const { setOnboardingFormSubmitted, setMenuItemClicked } =
    useOnboardingActions()

  const { me } = useCacheState()
  const isMarketsUnlocked = isMarketsUnlockedFor(me)

  return (
    <NavMenu>
      <Link
        url={ROUTE_HOME}
        rel="home"
        viewTransition
        onClick={() => {
          setOnboardingFormSubmitted(false)
          setMenuItemClicked('/')
        }}
      >
        {translate('Prisync.menu.home')}
      </Link>
      {menuItemClicked === '/onboarding' &&
        !isCompleted &&
        isOnboardingStarted && (
          <Link url={ROUTE_ONBOARDING} viewTransition>
            {translate('Prisync.menu.onboarding')}
          </Link>
        )}
      {isMarketsUnlocked && (
        <Link
          url={ROUTE_MARKETS}
          viewTransition
          onClick={() => {
            setOnboardingFormSubmitted(false)
            setMenuItemClicked(ROUTE_MARKETS)
          }}
        >
          {translate('Prisync.menu.markets')}
        </Link>
      )}
      <Link
        url={ROUTE_PREFERENCES}
        viewTransition
        onClick={() => {
          setOnboardingFormSubmitted(false)
          setMenuItemClicked('/settings')
        }}
      >
        {translate('Prisync.menu.settings')}
      </Link>
      <Link
        url={ROUTE_SUBSCRIPTION}
        viewTransition
        onClick={() => {
          setOnboardingFormSubmitted(false)
          setMenuItemClicked('/subscription')
        }}
      >
        {translate('Prisync.menu.subscription')}
      </Link>
    </NavMenu>
  )
}

export default MainMenu
